import {question, comment} from '@/api-services'
import {errorHandler, successHandler} from '@/utils/handler'
import {toast} from '@/utils/toast'
import {defineStore} from 'pinia'
import {parseLinkHeader, paginationHandler} from '@/utils/common'

export const useQuestionStore = defineStore('questionStore', {
  state: () => ({
    allQuestions: [],
    repliedQuestions: [],
    unAnsweredQuestions: [],
    question: {},
    localQuestion: {},
    isUpdateSuccess: false,
    isCreateSuccess: false,
    commentLoading: false,
    updateLoading: false,
    replyLoading: false,
    localLoading: false,
    loading: false,
    error: null,
    links: {},
  }),
  getters: {
    getSlicedRepliedQueries() {
      return this.repliedQuestions.slice(0, 4)
    },
  },
  actions: {
    async getLocalQuestion() {
      this.localLoading = true
      try {
        const response = await JSON.parse(localStorage.getItem('question'))
        this.localQuestion = response
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.localLoading = false
      }
    },

    async getRepliedQueries() {
      this.loading = true
      try {
        const response = await question.getRepliedQueries()
        const data = await response.data
        this.links = parseLinkHeader(response.headers.link)
        this.repliedQuestions = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getUnAnsweredQuestions() {
      this.loading = true
      try {
        const response = await question.getUnAnsweredQuestions()
        const data = await response.data
        this.links = parseLinkHeader(response.headers.link)
        this.unAnsweredQuestions = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getAllQuestions() {
      this.loading = true
      try {
        const response = await question.get()
        const data = response.data
        this.links = parseLinkHeader(response.headers.link)
        this.allQuestions = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async getQuestionsByUserId() {
      this.loading = true
      try {
        const response = await question.getQuestionByUserId()
        const data = response.data
        this.links = parseLinkHeader(response.headers.link)
        this.allQuestions = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    persistQuestion(payload) {
      this.loading = true
      localStorage.setItem('question', JSON.stringify(payload))
      this.loading = false
    },

    async getQuestionById(id) {
      this.loading = true
      try {
        const response = await question.getById(id)
        const data = response.data
        this.question = data
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.loading = false
      }
    },

    async addQuestion(payload) {
      this.updateLoading = true
      try {
        const response = await question.create(payload)
        const data = response.data
        this.questionDetail = data
        this.isCreateSuccess = true
        toast.success(successHandler('CREATE_QUESTION_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.updateLoading = false
      }
    },

    async updateQuestion(payload, id) {
      this.updateLoading = true
      try {
        const response = await question.update(payload, id)
        const data = response.data
        this.questionDetail = data
        this.isUpdateSuccess = true
        toast.success(successHandler('UPDATE_QUESTION_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.updateLoading = false
      }
    },

    async addReplyToQuestion(payload) {
      this.replyLoading = true
      try {
        await question.postAnswer(payload)
        toast.success(successHandler('REPLY_QUESTION_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.replyLoading = false
      }
    },

    async addComment(payload, answerId) {
      this.commentLoading = true
      try {
        await comment.postComment(payload, answerId)
        toast.success(successHandler('ADD_COMMENT_SUCCESS'))
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      } finally {
        this.commentLoading = false
      }
    },

    async getNextPage(data, type='ALL') {
      const {value} = data
      try {
        const response = await paginationHandler(this.links.next)
        if (type==='REPLIED_QUESTION') {
          this.repliedQuestions = [...value, ...response.data]
        }
        if (type==='UNANSWERED_QUESTION') {
          this.unAnsweredQuestions = [...value, ...response.data]
        }
        this.allQuestions = [...value, ...response.data]
        this.links = parseLinkHeader(response.headers.link)
      } catch (error) {
        error.map((e) => {
          const errorMsg = errorHandler(e)
          this.error = errorMsg
          toast.error(errorMsg)
        })
      }
    },
  },
})
